import { object, string } from 'yup';
import { CreateCommand } from '../../../entity/RealtimeEvent.js';
import { RealtimeEventType } from '../../../enums.js';

const SCHEMA = object({
  id: string().required(),
});

/**
 * MySpaceMySolicitationsRefreshEvent
 *
 * - Evento emitido quando a aba de solicitações do meu espaço precisa ser atualizada.
 * - Isso pode acontecer quando: O card é arquivado.
 */
export class MySpaceMySolicitationsRefreshEvent extends CreateCommand(
  RealtimeEventType.MySpaceMySolicitationsRefresh,
  SCHEMA,
) {}
